import { useState, useEffect } from "react";
import { submitIntake, checkAlreadySubmitted } from "./db";

const fontLink = document.createElement("link");
fontLink.rel = "stylesheet";
fontLink.href = "https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@600;700;800&family=DM+Sans:wght@300;400;500;600;700&display=swap";
document.head.appendChild(fontLink);

const C = {
  navy:"#0D1F3C", navyLight:"#1A3460", gray:"#D9DDDC", grayDark:"#C8CCCA",
  grayDarker:"#B0B4B3", steel:"#4A7FA5", steelDark:"#3A6A8E", white:"#FFFFFF",
};

const css = `
  *,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
  html,body{min-height:100%;background:${C.gray};font-family:'DM Sans',sans-serif;color:${C.navy}}
  .intake-root{min-height:100vh;display:flex;flex-direction:column;align-items:center;justify-content:flex-start;padding:40px 20px 80px;background:${C.gray}}
  .intake-body{display:flex;align-items:flex-start;gap:20px;width:100%;max-width:820px}
  .step-sidebar{flex-shrink:0;width:44px;display:flex;flex-direction:column;align-items:center;gap:4px;padding-top:4px}
  .step-pip{width:28px;height:28px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-family:'DM Sans',sans-serif;font-size:10px;font-weight:700;transition:all 0.15s;border:2px solid transparent;flex-shrink:0;line-height:1}
  .step-pip.completed{background:${C.navy};color:white;cursor:pointer;border-color:${C.navy}}
  .step-pip.completed:hover{background:${C.navyLight};border-color:${C.navyLight}}
  .step-pip.current{background:white;color:${C.navy};border-color:${C.navy};cursor:default}
  .step-pip.locked{background:transparent;color:${C.grayDarker};border-color:${C.grayDark};cursor:default}
  .step-pip-connector{width:2px;height:6px;background:${C.grayDark};border-radius:1px}
  .step-pip-connector.done{background:${C.navy}}
  .intake-logo{display:flex;flex-direction:column;align-items:center;margin-bottom:36px}
  .logo-even{font-family:'Barlow Condensed',sans-serif;font-weight:800;font-size:28px;letter-spacing:0.04em;color:${C.navy};line-height:0.88;text-transform:uppercase}
  .logo-ground{font-family:'Barlow Condensed',sans-serif;font-weight:600;font-size:28px;letter-spacing:0.12em;color:rgba(13,31,60,0.4);line-height:0.88;text-transform:uppercase}
  .logo-sub{font-size:10px;font-weight:600;letter-spacing:0.22em;text-transform:uppercase;color:${C.grayDarker};margin-top:8px}
  .intake-card{background:${C.white};border-radius:6px;width:100%;max-width:600px;overflow:hidden;box-shadow:0 8px 40px rgba(13,31,60,0.10)}
  .progress-bar-wrap{height:3px;background:${C.grayDark};width:100%}
  .progress-bar-fill{height:100%;background:${C.navy};transition:width 0.4s ease}
  .step-header{padding:28px 36px 0}
  .step-count{font-size:10px;font-weight:700;letter-spacing:0.22em;text-transform:uppercase;color:${C.grayDarker};margin-bottom:8px}
  .step-title{font-family:'Barlow Condensed',sans-serif;font-weight:800;font-size:26px;text-transform:uppercase;letter-spacing:0.03em;color:${C.navy};line-height:1.1;margin-bottom:4px}
  .step-subtitle{font-size:13px;color:${C.grayDarker};font-weight:400;line-height:1.6;margin-bottom:0}
  .step-body{padding:24px 36px 32px}
  .field-group{margin-bottom:18px}
  .field-label{font-size:10px;font-weight:700;letter-spacing:0.18em;text-transform:uppercase;color:${C.grayDarker};margin-bottom:6px;display:block}
  .field-note{font-size:11px;color:${C.grayDarker};margin-top:4px;line-height:1.55;font-style:italic}
  .field-input,.field-select,.field-textarea{width:100%;font-family:'DM Sans',sans-serif;font-size:14px;border:1.5px solid ${C.grayDark};border-radius:3px;padding:10px 12px;color:${C.navy};background:${C.white};outline:none;transition:border 0.15s;-webkit-appearance:none}
  .field-input:focus,.field-select:focus,.field-textarea:focus{border-color:${C.steel}}
  .field-textarea{resize:vertical;min-height:80px;line-height:1.6}
  .field-row{display:grid;grid-template-columns:1fr 1fr;gap:14px}
  .field-row.three{grid-template-columns:1fr 1fr 1fr}
  .choice-grid{display:flex;flex-direction:column;gap:10px}
  .choice-grid.two-col{display:grid;grid-template-columns:1fr 1fr;gap:10px}
  .choice-card{border:1.5px solid ${C.grayDark};border-radius:4px;padding:13px 16px;cursor:pointer;transition:all 0.15s;display:flex;align-items:flex-start;gap:12px;background:${C.white}}
  .choice-card:hover{border-color:${C.steel};background:#f5f8fb}
  .choice-card.selected{border-color:${C.navy};background:#f0f3f8}
  .choice-radio{width:16px;height:16px;border-radius:50%;border:2px solid ${C.grayDark};flex-shrink:0;margin-top:2px;transition:all 0.15s;display:flex;align-items:center;justify-content:center}
  .choice-card.selected .choice-radio{border-color:${C.navy};background:${C.navy}}
  .choice-radio-dot{width:6px;height:6px;border-radius:50%;background:white}
  .choice-label{font-size:13px;font-weight:600;color:${C.navy};line-height:1.3}
  .choice-desc{font-size:11px;color:${C.grayDarker};margin-top:2px;line-height:1.5;font-weight:400}
  .segment{display:flex;border:1.5px solid ${C.grayDark};border-radius:4px;overflow:hidden}
  .segment-option{flex:1;padding:9px 8px;text-align:center;font-size:11px;font-weight:700;letter-spacing:0.08em;text-transform:uppercase;cursor:pointer;transition:all 0.15s;color:${C.grayDarker};border-right:1px solid ${C.grayDark};background:${C.white}}
  .segment-option:last-child{border-right:none}
  .segment-option.selected{background:${C.navy};color:white;border-color:${C.navy}}
  .segment-option:hover:not(.selected){background:${C.gray}}
  .sub-section{background:#f7f8f9;border-radius:4px;padding:18px 20px;margin-top:4px;border:1px solid ${C.grayDark}}
  .sub-section-title{font-size:10px;font-weight:700;letter-spacing:0.18em;text-transform:uppercase;color:${C.grayDarker};margin-bottom:14px}
  .form-divider{border-top:1px solid ${C.gray};margin:18px 0 14px;padding-top:14px;font-size:10px;font-weight:700;letter-spacing:0.18em;text-transform:uppercase;color:${C.grayDarker}}
  .upload-zone{border:2px dashed ${C.grayDark};border-radius:4px;padding:24px;text-align:center;cursor:pointer;transition:all 0.15s;background:#fafafa}
  .upload-zone:hover,.upload-zone.dragging{border-color:${C.steel};background:#f0f5fa}
  .upload-zone-icon{font-size:24px;margin-bottom:8px}
  .upload-zone-text{font-size:12px;font-weight:600;color:${C.grayDarker}}
  .upload-zone-sub{font-size:11px;color:${C.grayDarker};margin-top:3px}
  .upload-files{display:flex;flex-wrap:wrap;gap:8px;margin-top:10px}
  .upload-file-tag{display:flex;align-items:center;gap:6px;padding:4px 10px;background:${C.gray};border-radius:3px;font-size:11px;font-weight:600;color:${C.navy};border:1px solid ${C.grayDark}}
  .upload-remove{cursor:pointer;color:#8B2020;font-weight:900;font-size:13px;line-height:1}
  .step-nav{display:flex;justify-content:space-between;align-items:center;padding:20px 36px 28px;border-top:1px solid ${C.gray}}
  .btn{display:inline-flex;align-items:center;gap:6px;padding:11px 24px;border-radius:3px;font-family:'DM Sans',sans-serif;font-size:11px;font-weight:700;letter-spacing:0.12em;text-transform:uppercase;border:none;cursor:pointer;transition:all 0.15s}
  .btn-primary{background:${C.navy};color:#fff}
  .btn-primary:hover{background:${C.navyLight}}
  .btn-primary:disabled{background:${C.grayDark};cursor:not-allowed}
  .btn-ghost{background:transparent;color:${C.navy};border:1.5px solid ${C.grayDark}}
  .btn-ghost:hover{background:${C.gray}}
  .btn-back{background:transparent;color:${C.grayDarker};border:none;padding-left:0;font-size:11px}
  .btn-back:hover{color:${C.navy}}
  .complete-screen{padding:52px 36px;text-align:center}
  .complete-icon{font-size:40px;margin-bottom:20px}
  .complete-title{font-family:'Barlow Condensed',sans-serif;font-weight:800;font-size:32px;text-transform:uppercase;letter-spacing:0.03em;color:${C.navy};margin-bottom:12px}
  .complete-text{font-size:14px;color:${C.grayDarker};line-height:1.75;max-width:420px;margin:0 auto}
  .field-error{font-size:11px;color:#8B2020;margin-top:4px;font-weight:600}
  @media(max-width:600px){
    .intake-root{padding:24px 12px 60px}
    .step-sidebar{display:none}
    .intake-body{flex-direction:column;align-items:center}
    .step-header{padding:22px 22px 0}
    .step-body{padding:18px 22px 24px}
    .step-nav{padding:16px 22px 22px}
    .field-row,.field-row.three{grid-template-columns:1fr}
    .choice-grid.two-col{grid-template-columns:1fr}
  }
`;
const styleEl = document.createElement("style");
styleEl.textContent = css;
document.head.appendChild(styleEl);

function ChoiceCard({ value, selected, onSelect, label, desc }) {
  return (
    <div className={`choice-card ${selected ? "selected" : ""}`} onClick={() => onSelect(value)}>
      <div className="choice-radio">{selected && <div className="choice-radio-dot" />}</div>
      <div>
        <div className="choice-label">{label}</div>
        {desc && <div className="choice-desc">{desc}</div>}
      </div>
    </div>
  );
}

function Segment({ options, value, onChange }) {
  return (
    <div className="segment">
      {options.map(o => (
        <div key={o.value} className={`segment-option ${value === o.value ? "selected" : ""}`} onClick={() => onChange(o.value)}>
          {o.label}
        </div>
      ))}
    </div>
  );
}

function FG({ label, note, error, children }) {
  return (
    <div className="field-group">
      {label && <label className="field-label">{label}</label>}
      {children}
      {note && <div className="field-note">{note}</div>}
      {error && <div className="field-error">{error}</div>}
    </div>
  );
}

export default function App() {
  const clientId = new URLSearchParams(window.location.search).get("client");
  const [step, setStep] = useState(0);
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [alreadySubmitted, setAlreadySubmitted] = useState(false);
  const [checking, setChecking] = useState(true);
  const [dragging, setDragging] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState(null);

  useEffect(() => {
    async function check() {
      if (clientId) {
        const already = await checkAlreadySubmitted(clientId);
        if (already) setAlreadySubmitted(true);
      }
      setChecking(false);
    }
    check();
  }, [clientId]);

  const [f, setF] = useState({
    // Step 1
    firstName: "", lastName: "", intakePhone: "", intakeEmail: "",
    registrationCity: "", registrationState: "", registrationZip: "",
    // Step 2 — Vehicle and Vehicle Search
    vehicleCondition: "new",
    vehicleYear: "", vehicleMake: "", vehicleModel: "", vehicleTrim: "",
    vehiclePackages: "", vehicleExteriorColor: "", vehicleInteriorColor: "",
    purchaseOrLease: "",
    hasSpecificVehicle: "",
    specificYear: "", specificMake: "", specificModel: "", specificTrim: "",
    specificDealer: "", specificDealerCity: "", specificDealerState: "",
    specificAsking: "", specificStock: "", hasReachedOut: "", reachedOutResponse: "",
    maxMileage: "", cpoCertified: "", usedBudget: "",
    // Step 3 — Payment
    paymentMethod: "", loanTerm: "", creditScore: "",
    outsideLender: "", outsideRate: "",
    leaseMilesPerYear: "", leaseTerm: "", targetMonthlyPayment: "",
    // Step 4 — Trade-In
    hasTrade: "",
    tradeYear: "", tradeMake: "", tradeModel: "", tradeTrim: "", tradeVin: "",
    tradeMileage: "", tradeCondition: "", tradeAccident: "", tradeAccidentDesc: "",
    tradeLoan: "", tradeLoanPayoff: "", tradeLoanLender: "",
    tradeExistingOffer: "", tradeOfferSource: "", tradeOfferAmount: "",
    tradeClientEstimate: "", tradePhotos: [],
    // Step 5 — Travel and Timeline
    travelDistance: "", timeline: "",
    // Step 6 — GAP, Warranty, Add-Ons
    gapInterest: "", warrantyInterest: "",
    hasAddOns: "", addOnsDescription: "",
    // Step 7 — Setting Expectations
    maxBudget: "", successOutcome: "",
    // Step 8 — Best Time for Call
    callBestTime: "", callWeekend: "",
    // Step 9 — Contact Method
    contactMethod: "",
    // Step 10 — Concerns
    anythingElse: "",
  });

  const set = (k, v) => setF(p => ({ ...p, [k]: v }));
  const clearErr = (k) => setErrors(p => { const n = { ...p }; delete n[k]; return n; });

  const isUsed = f.vehicleCondition === "used";
  const isLease = f.purchaseOrLease === "lease";
  const isFinancing = ["manufacturer", "outside", "unsure"].includes(f.paymentMethod);

  const STEPS = [
    { id: "name",         title: "Let's Get Started",          subtitle: "Tell us who you are and where the vehicle will be registered." },
    { id: "vehicle",      title: "The Vehicle",                subtitle: "Tell us about the vehicle you're looking for." },
    { id: "payment",      title: isLease ? "Lease Details" : "Payment & Financing", subtitle: isLease ? "Tell us about your lease preferences." : "How are you planning to pay?" },
    { id: "tradein",      title: "Trade-In",                   subtitle: "Do you have a vehicle you're looking to trade in?" },
    { id: "travel",       title: "Travel & Timeline",          subtitle: "How far are you willing to go and when are you looking to buy?" },
    { id: "addons",       title: "GAP, Warranty & Add-Ons",    subtitle: "Tell us about any additional coverage or items you're considering." },
    { id: "expectations", title: "Setting Expectations",       subtitle: "Help us understand what a successful outcome looks like for you." },
    { id: "calltime",     title: "Best Time to Reach You",     subtitle: "Even Ground will call to confirm everything before we begin. When works best?" },
    { id: "contact",      title: "Keeping You Informed",       subtitle: "What's the best way to keep you updated as we work on your deal?" },
    { id: "other",        title: "Any Concerns or Questions",  subtitle: "Anything else Even Ground should know before getting started." },
  ];

  const totalSteps = STEPS.length;
  const currentStep = STEPS[step];
  const progress = ((step + 1) / totalSteps) * 100;

  const validate = () => {
    const errs = {};
    const id = currentStep.id;

    if (id === "name") {
      if (!f.firstName.trim()) errs.firstName = "Required";
      if (!f.lastName.trim()) errs.lastName = "Required";
      if (!f.intakePhone.trim()) errs.intakePhone = "Required";
      if (!f.intakeEmail.trim()) errs.intakeEmail = "Required";
      if (!f.registrationZip.trim()) errs.registrationZip = "Required";
    }
    if (id === "vehicle") {
      if (!f.vehicleYear.trim()) errs.vehicleYear = "Required";
      if (!f.vehicleMake.trim()) errs.vehicleMake = "Required";
      if (!f.vehicleModel.trim()) errs.vehicleModel = "Required";
      if (!f.vehicleTrim.trim()) errs.vehicleTrim = "Required";
      if (!isUsed && !f.purchaseOrLease) errs.purchaseOrLease = "Please select one";
      if (!f.hasSpecificVehicle) errs.hasSpecificVehicle = "Please select one";
    }
    if (id === "payment") {
      if (!isLease && !f.paymentMethod) errs.paymentMethod = "Please select one";
    }
    if (id === "tradein") {
      if (!f.hasTrade) errs.hasTrade = "Please select one";
      if (f.hasTrade === "yes") {
        if (!f.tradeYear.trim()) errs.tradeYear = "Required";
        if (!f.tradeMake.trim()) errs.tradeMake = "Required";
        if (!f.tradeModel.trim()) errs.tradeModel = "Required";
        if (!f.tradeMileage.trim()) errs.tradeMileage = "Required";
        if (!f.tradeCondition) errs.tradeCondition = "Required";
        if (!f.tradeAccident) errs.tradeAccident = "Required";
        if (!f.tradeLoan) errs.tradeLoan = "Required";
        if (!f.tradeExistingOffer) errs.tradeExistingOffer = "Required";
      }
    }
    if (id === "travel") {
      if (!f.travelDistance) errs.travelDistance = "Please select one";
      if (!f.timeline) errs.timeline = "Please select one";
    }
    if (id === "addons") {
      if (!f.gapInterest) errs.gapInterest = "Please select one";
      if (!f.warrantyInterest) errs.warrantyInterest = "Please select one";
      if (!f.hasAddOns) errs.hasAddOns = "Please select one";
    }
    if (id === "expectations") {
      if (!f.successOutcome.trim()) errs.successOutcome = "Required";
    }
    if (id === "calltime" && !f.callBestTime) errs.callBestTime = "Please select one";
    if (id === "contact" && !f.contactMethod) errs.contactMethod = "Please select one";

    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const next = async () => {
    if (validate()) {
      if (step < totalSteps - 1) {
        setStep(s => s + 1);
      } else {
        setSubmitting(true);
        setSubmitError(null);
        try {
          await submitIntake(f, clientId);
          setSubmitted(true);
        } catch (e) {
          console.error(e);
          setSubmitError("Something went wrong. Please try again or contact thomas@getevenground.com.");
        } finally {
          setSubmitting(false);
        }
      }
    }
  };
  const back = () => { setErrors({}); setStep(s => s - 1); };

  const readFiles = (files) => {
    Array.from(files).forEach(file => {
      const reader = new FileReader();
      reader.onload = (e) => {
        setF(p => ({ ...p, tradePhotos: [...p.tradePhotos, { name: file.name, type: file.type, dataUrl: e.target.result }] }));
      };
      reader.readAsDataURL(file);
    });
  };

  if (checking) {
    return (
      <div className="intake-root">
        <div className="intake-logo">
          <div className="logo-even">Even</div>
          <div className="logo-ground">Ground</div>
        </div>
        <div className="intake-card" style={{maxWidth:600,width:"100%"}}>
          <div className="complete-screen">
            <div className="complete-text" style={{color:"#B0B4B3"}}>Loading...</div>
          </div>
        </div>
      </div>
    );
  }

  if (alreadySubmitted) {
    return (
      <div className="intake-root">
        <div className="intake-logo">
          <div className="logo-even">Even</div>
          <div className="logo-ground">Ground</div>
        </div>
        <div className="intake-card" style={{maxWidth:600,width:"100%"}}>
          <div className="complete-screen">
            <div className="complete-icon">✓</div>
            <div className="complete-title">Already Received</div>
            <div className="complete-text">
              Your intake has already been submitted. Even Ground has your information and will be in touch shortly. If you believe this is an error or need to make a change, contact us directly at{" "}
              <a href="mailto:thomas@getevenground.com" style={{color:"#4A7FA5",textDecoration:"none",fontWeight:600}}>thomas@getevenground.com</a>.
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (submitted) {
    return (
      <div className="intake-root">
        <div className="intake-logo">
          <div className="logo-even">Even</div>
          <div className="logo-ground">Ground</div>
        </div>
        <div className="intake-card">
          <div className="complete-screen">
            <div className="complete-icon">✓</div>
            <div className="complete-title">You're All Set</div>
            <div className="complete-text">
              Your intake has been received. Even Ground will review your information and be in touch to confirm everything before we begin.
              {" "}We'll aim to reach you {f.callBestTime === "morning" ? "in the morning" : f.callBestTime === "afternoon" ? "in the afternoon" : f.callBestTime === "evening" ? "in the evening" : "at your convenience"} via {f.contactMethod === "email" ? "email" : f.contactMethod === "phone" ? "phone" : "text"}.
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="intake-root">
      <div className="intake-logo">
        <div className="logo-even">Even</div>
        <div className="logo-ground">Ground</div>
        <div className="logo-sub">Client Intake</div>
      </div>
      <div className="intake-body">
        <div className="step-sidebar">
          {STEPS.map((s, i) => (
            <div key={s.id} style={{display:"flex",flexDirection:"column",alignItems:"center"}}>
              <div
                className={`step-pip ${i < step ? "completed" : i === step ? "current" : "locked"}`}
                onClick={() => { if (i < step) { setErrors({}); setStep(i); } }}
                title={s.title}
              >
                {i < step ? "✓" : i + 1}
              </div>
              {i < STEPS.length - 1 && <div className={`step-pip-connector ${i < step ? "done" : ""}`} />}
            </div>
          ))}
        </div>

        <div className="intake-card" style={{flex:1,minWidth:0}}>
          <div className="progress-bar-wrap">
            <div className="progress-bar-fill" style={{ width: `${progress}%` }} />
          </div>
          <div className="step-header">
            <div className="step-count">Step {step + 1} of {totalSteps}</div>
            <div className="step-title">{currentStep.title}</div>
            {currentStep.subtitle && <div className="step-subtitle" style={{marginBottom:0,paddingBottom:16,borderBottom:`1px solid ${C.gray}`}}>{currentStep.subtitle}</div>}
          </div>

          <div className="step-body">

            {/* ── Step 1: Name and Registration ── */}
            {currentStep.id === "name" && (
              <>
                <div className="field-row">
                  <FG label="First Name *" error={errors.firstName}>
                    <input className="field-input" value={f.firstName} onChange={e=>{set("firstName",e.target.value);clearErr("firstName");}} placeholder="Marcus" autoFocus />
                  </FG>
                  <FG label="Last Name *" error={errors.lastName}>
                    <input className="field-input" value={f.lastName} onChange={e=>{set("lastName",e.target.value);clearErr("lastName");}} placeholder="Webb" />
                  </FG>
                </div>
                <FG label="Phone *" error={errors.intakePhone}>
                  <input className="field-input" type="tel" value={f.intakePhone} onChange={e=>{set("intakePhone",e.target.value);clearErr("intakePhone");}} placeholder="(312) 555-0100" style={{maxWidth:240}} />
                </FG>
                <FG label="Email *" error={errors.intakeEmail}>
                  <input className="field-input" type="email" value={f.intakeEmail} onChange={e=>{set("intakeEmail",e.target.value);clearErr("intakeEmail");}} placeholder="you@email.com" style={{maxWidth:320}} />
                </FG>
                <div className="form-divider">Registration Location</div>
                <div className="field-row">
                  <FG label="City">
                    <input className="field-input" value={f.registrationCity} onChange={e=>set("registrationCity",e.target.value)} placeholder="Chicago" />
                  </FG>
                  <FG label="State">
                    <input className="field-input" value={f.registrationState} onChange={e=>set("registrationState",e.target.value)} placeholder="IL" />
                  </FG>
                </div>
                <FG label="Zip Code *" error={errors.registrationZip}>
                  <input className="field-input" value={f.registrationZip} onChange={e=>{set("registrationZip",e.target.value);clearErr("registrationZip");}} placeholder="60614" style={{maxWidth:180}} />
                </FG>
              </>
            )}

            {/* ── Step 2: Vehicle and Vehicle Search ── */}
            {currentStep.id === "vehicle" && (
              <>
                <FG label="New or Used">
                  <Segment
                    options={[{value:"new",label:"New"},{value:"used",label:"Used"}]}
                    value={f.vehicleCondition}
                    onChange={v => { set("vehicleCondition", v); if (v === "used") set("purchaseOrLease", "purchase"); }}
                  />
                </FG>
                <div className="field-row three">
                  <FG label="Year *" error={errors.vehicleYear}>
                    <select className="field-input" value={f.vehicleYear} onChange={e=>{set("vehicleYear",e.target.value);clearErr("vehicleYear");}}>
                      <option value="">Year</option>
                      {Array.from({length:36},(_,i)=>2026-i).map(y=><option key={y} value={y}>{y}</option>)}
                    </select>
                  </FG>
                  <FG label="Make *" error={errors.vehicleMake}>
                    <input className="field-input" value={f.vehicleMake} onChange={e=>{set("vehicleMake",e.target.value);clearErr("vehicleMake");}} placeholder="BMW" />
                  </FG>
                  <FG label="Model *" error={errors.vehicleModel}>
                    <input className="field-input" value={f.vehicleModel} onChange={e=>{set("vehicleModel",e.target.value);clearErr("vehicleModel");}} placeholder="X5" />
                  </FG>
                </div>
                <FG label="Trim *" error={errors.vehicleTrim}>
                  <input className="field-input" value={f.vehicleTrim} onChange={e=>{set("vehicleTrim",e.target.value);clearErr("vehicleTrim");}} placeholder="xDrive40i" />
                </FG>
                <FG label="Packages" note="Any additional packages you want. e.g. Sport Package, Premium Plus, Driver Assistance.">
                  <input className="field-input" value={f.vehiclePackages} onChange={e=>set("vehiclePackages",e.target.value)} placeholder="Sport Package, Premium Plus..." />
                </FG>
                <div className="field-row">
                  <FG label="Exterior Color">
                    <input className="field-input" value={f.vehicleExteriorColor} onChange={e=>set("vehicleExteriorColor",e.target.value)} placeholder="Alpine White" />
                  </FG>
                  <FG label="Interior Color">
                    <input className="field-input" value={f.vehicleInteriorColor} onChange={e=>set("vehicleInteriorColor",e.target.value)} placeholder="Black leather" />
                  </FG>
                </div>

                {/* Purchase or Lease — new only */}
                {!isUsed && (
                  <>
                    <div className="form-divider">Purchase or Lease</div>
                    <FG error={errors.purchaseOrLease}>
                      <div className="choice-grid two-col">
                        <ChoiceCard value="purchase" selected={f.purchaseOrLease==="purchase"} onSelect={v=>{set("purchaseOrLease",v);clearErr("purchaseOrLease");}} label="Purchase" desc="Buy outright or with financing." />
                        <ChoiceCard value="lease" selected={f.purchaseOrLease==="lease"} onSelect={v=>{set("purchaseOrLease",v);clearErr("purchaseOrLease");}} label="Lease" desc="Drive it for a set term with a monthly payment." />
                      </div>
                    </FG>
                  </>
                )}

                {/* Vehicle Search */}
                <div className="form-divider">Vehicle Search</div>
                <FG label="Do you have a specific vehicle identified?" error={errors.hasSpecificVehicle}>
                  <div className="choice-grid two-col">
                    <ChoiceCard value="yes" selected={f.hasSpecificVehicle==="yes"} onSelect={v=>{set("hasSpecificVehicle",v);clearErr("hasSpecificVehicle");}} label="Yes" desc="I know the exact vehicle I want." />
                    <ChoiceCard value="no" selected={f.hasSpecificVehicle==="no"} onSelect={v=>{set("hasSpecificVehicle",v);clearErr("hasSpecificVehicle");}} label="No" desc="I'd like Even Ground to find options." />
                  </div>
                </FG>

                {f.hasSpecificVehicle === "yes" && (
                  <div className="sub-section">
                    <div className="sub-section-title">Vehicle Details</div>
                    <div className="field-row">
                      <FG label="Dealer Name"><input className="field-input" value={f.specificDealer} onChange={e=>set("specificDealer",e.target.value)} placeholder="BMW of Chicago" /></FG>
                      <FG label="Stock Number"><input className="field-input" value={f.specificStock} onChange={e=>set("specificStock",e.target.value)} placeholder="P12345" /></FG>
                    </div>
                    <div className="field-row">
                      <FG label="City"><input className="field-input" value={f.specificDealerCity} onChange={e=>set("specificDealerCity",e.target.value)} placeholder="Chicago" /></FG>
                      <FG label="State"><input className="field-input" value={f.specificDealerState} onChange={e=>set("specificDealerState",e.target.value)} placeholder="IL" /></FG>
                    </div>
                    {isUsed && (
                      <FG label="Asking Price ($)">
                        <input className="field-input" type="number" value={f.specificAsking} onChange={e=>set("specificAsking",e.target.value)} placeholder="42000" style={{maxWidth:200}} />
                      </FG>
                    )}
                    <FG label="Have you reached out to this dealer?">
                      <Segment options={[{value:"yes",label:"Yes"},{value:"no",label:"Not yet"}]} value={f.hasReachedOut} onChange={v=>set("hasReachedOut",v)} />
                    </FG>
                    {f.hasReachedOut === "yes" && (
                      <FG label="What was their response?">
                        <textarea className="field-textarea" value={f.reachedOutResponse} onChange={e=>set("reachedOutResponse",e.target.value)} placeholder="e.g. They quoted $53,500. Still negotiating." />
                      </FG>
                    )}
                  </div>
                )}

                {f.hasSpecificVehicle === "no" && isUsed && (
                  <div className="sub-section">
                    <div className="sub-section-title">Search Parameters</div>
                    <FG label="Maximum Mileage">
                      <input className="field-input" type="number" value={f.maxMileage} onChange={e=>set("maxMileage",e.target.value)} placeholder="50000" style={{maxWidth:200}} />
                    </FG>
                    <FG label="Certified Pre-Owned (CPO)?">
                      <div className="choice-grid">
                        <ChoiceCard value="yes" selected={f.cpoCertified==="yes"} onSelect={v=>set("cpoCertified",v)} label="Yes — CPO only" />
                        <ChoiceCard value="no" selected={f.cpoCertified==="no"} onSelect={v=>set("cpoCertified",v)} label="No — open to non-CPO" />
                        <ChoiceCard value="open" selected={f.cpoCertified==="open"} onSelect={v=>set("cpoCertified",v)} label="Open to either" />
                      </div>
                    </FG>
                    <FG label="Maximum Budget — Out the Door ($)" note="Include taxes, fees, and all costs.">
                      <input className="field-input" type="number" value={f.usedBudget} onChange={e=>set("usedBudget",e.target.value)} placeholder="45000" style={{maxWidth:220}} />
                    </FG>
                  </div>
                )}
              </>
            )}

            {/* ── Step 3: Payment ── */}
            {currentStep.id === "payment" && isLease && (
              <>
                <FG label="Estimated miles per year" note="Lease mileage allowances are set at signing. Going over is costly.">
                  <div className="choice-grid two-col">
                    <ChoiceCard value="10000" selected={f.leaseMilesPerYear==="10000"} onSelect={v=>set("leaseMilesPerYear",v)} label="10,000 / yr" />
                    <ChoiceCard value="12000" selected={f.leaseMilesPerYear==="12000"} onSelect={v=>set("leaseMilesPerYear",v)} label="12,000 / yr" />
                    <ChoiceCard value="15000" selected={f.leaseMilesPerYear==="15000"} onSelect={v=>set("leaseMilesPerYear",v)} label="15,000 / yr" />
                    <ChoiceCard value="more" selected={f.leaseMilesPerYear==="more"} onSelect={v=>set("leaseMilesPerYear",v)} label="More than 15,000" />
                  </div>
                </FG>
                <FG label="Preferred lease term">
                  <div className="choice-grid two-col">
                    <ChoiceCard value="24" selected={f.leaseTerm==="24"} onSelect={v=>set("leaseTerm",v)} label="24 months" desc="2-year lease" />
                    <ChoiceCard value="36" selected={f.leaseTerm==="36"} onSelect={v=>set("leaseTerm",v)} label="36 months" desc="3-year lease" />
                  </div>
                </FG>
                <FG label="Target monthly payment" note="Even Ground will flag early if the vehicle and lease structure don't align with this number.">
                  <input className="field-input" type="number" value={f.targetMonthlyPayment} onChange={e=>set("targetMonthlyPayment",e.target.value)} placeholder="650" style={{maxWidth:180}} />
                </FG>
              </>
            )}

            {currentStep.id === "payment" && !isLease && (
              <>
                <FG label="How are you planning to pay?" error={errors.paymentMethod}>
                  <div className="choice-grid">
                    <ChoiceCard value="cash" selected={f.paymentMethod==="cash"} onSelect={v=>{set("paymentMethod",v);clearErr("paymentMethod");}} label="Cash" desc="Full payment upfront. No financing needed." />
                    {!isUsed && <ChoiceCard value="manufacturer" selected={f.paymentMethod==="manufacturer"} onSelect={v=>{set("paymentMethod",v);clearErr("paymentMethod");}} label="Manufacturer Financing" desc="Through the dealership's lending arm." />}
                    <ChoiceCard value="outside" selected={f.paymentMethod==="outside"} onSelect={v=>{set("paymentMethod",v);clearErr("paymentMethod");}} label="Outside Financing" desc="Credit union or bank. I have or will arrange my own loan." />
                    <ChoiceCard value="unsure" selected={f.paymentMethod==="unsure"} onSelect={v=>{set("paymentMethod",v);clearErr("paymentMethod");}} label="Not Sure Yet" desc="I'd like Even Ground to advise on the best option." />
                  </div>
                </FG>
                {isFinancing && (
                  <div className="sub-section" style={{marginTop:6}}>
                    <div className="sub-section-title">Financing Details</div>
                    <FG label="Preferred Loan Term">
                      <div className="segment" style={{flexWrap:"wrap"}}>
                        {["36","48","60","72","84"].map(t=>(
                          <div key={t} className={`segment-option ${f.loanTerm===t?"selected":""}`} onClick={()=>set("loanTerm",t)}>{t} mo</div>
                        ))}
                      </div>
                    </FG>
                    <FG label="Estimated Credit Score" note="Helps identify your best financing path. Does not affect your service in any way.">
                      <div className="choice-grid">
                        <ChoiceCard value="750+" selected={f.creditScore==="750+"} onSelect={v=>set("creditScore",v)} label="750 and above" desc="Excellent" />
                        <ChoiceCard value="700-749" selected={f.creditScore==="700-749"} onSelect={v=>set("creditScore",v)} label="700 to 749" desc="Good" />
                        <ChoiceCard value="650-699" selected={f.creditScore==="650-699"} onSelect={v=>set("creditScore",v)} label="650 to 699" desc="Fair" />
                        <ChoiceCard value="600-649" selected={f.creditScore==="600-649"} onSelect={v=>set("creditScore",v)} label="600 to 649" desc="Below Average" />
                        <ChoiceCard value="below600" selected={f.creditScore==="below600"} onSelect={v=>set("creditScore",v)} label="Below 600" desc="I'd like to discuss my options" />
                        <ChoiceCard value="unsure" selected={f.creditScore==="unsure"} onSelect={v=>set("creditScore",v)} label="Not Sure" desc="I haven't checked recently" />
                      </div>
                    </FG>
                    {f.paymentMethod === "outside" && (
                      <div className="field-row" style={{marginTop:4}}>
                        <FG label="Lender Name"><input className="field-input" value={f.outsideLender} onChange={e=>set("outsideLender",e.target.value)} placeholder="Navy Federal, Chase..." /></FG>
                        <FG label="Rate Quoted (if known)"><input className="field-input" value={f.outsideRate} onChange={e=>set("outsideRate",e.target.value)} placeholder="5.9%" /></FG>
                      </div>
                    )}
                    <FG label="Target monthly payment (if applicable)" note="Share your target here so Even Ground can flag any gap early.">
                      <input className="field-input" type="number" value={f.targetMonthlyPayment} onChange={e=>set("targetMonthlyPayment",e.target.value)} placeholder="650" style={{maxWidth:180}} />
                    </FG>
                  </div>
                )}
              </>
            )}

            {/* ── Step 4: Trade-In ── */}
            {currentStep.id === "tradein" && (
              <>
                <FG label="Do you have a vehicle to trade in?" error={errors.hasTrade}>
                  <div className="choice-grid two-col">
                    <ChoiceCard value="yes" selected={f.hasTrade==="yes"} onSelect={v=>{set("hasTrade",v);clearErr("hasTrade");}} label="Yes" />
                    <ChoiceCard value="no" selected={f.hasTrade==="no"} onSelect={v=>{set("hasTrade",v);clearErr("hasTrade");}} label="No" />
                  </div>
                </FG>
                {f.hasTrade === "yes" && (
                  <div className="sub-section">
                    <div className="sub-section-title">Trade-In Details</div>
                    <div className="field-row three">
                      <FG label="Year *" error={errors.tradeYear}><input className="field-input" value={f.tradeYear} onChange={e=>{set("tradeYear",e.target.value);clearErr("tradeYear");}} placeholder="2021" /></FG>
                      <FG label="Make *" error={errors.tradeMake}><input className="field-input" value={f.tradeMake} onChange={e=>{set("tradeMake",e.target.value);clearErr("tradeMake");}} placeholder="Audi" /></FG>
                      <FG label="Model *" error={errors.tradeModel}><input className="field-input" value={f.tradeModel} onChange={e=>{set("tradeModel",e.target.value);clearErr("tradeModel");}} placeholder="Q5" /></FG>
                    </div>
                    <div className="field-row">
                      <FG label="Trim"><input className="field-input" value={f.tradeTrim} onChange={e=>set("tradeTrim",e.target.value)} placeholder="Premium Plus" /></FG>
                      <FG label="Mileage *" error={errors.tradeMileage}><input className="field-input" value={f.tradeMileage} onChange={e=>{set("tradeMileage",e.target.value);clearErr("tradeMileage");}} placeholder="38,400" /></FG>
                    </div>
                    <FG label="VIN (if known)" note="17-character vehicle identification number. Found on your registration, insurance card, or driver side door jamb.">
                      <input className="field-input" value={f.tradeVin} onChange={e=>set("tradeVin",e.target.value)} placeholder="1HGCM82633A123456" style={{fontFamily:"monospace",letterSpacing:"0.05em"}} />
                    </FG>
                    <FG label="Condition *" error={errors.tradeCondition}>
                      <div className="choice-grid two-col">
                        <ChoiceCard value="excellent" selected={f.tradeCondition==="excellent"} onSelect={v=>{set("tradeCondition",v);clearErr("tradeCondition");}} label="Excellent" desc="Like new. No visible flaws." />
                        <ChoiceCard value="good" selected={f.tradeCondition==="good"} onSelect={v=>{set("tradeCondition",v);clearErr("tradeCondition");}} label="Good" desc="Normal wear. No major issues." />
                        <ChoiceCard value="fair" selected={f.tradeCondition==="fair"} onSelect={v=>{set("tradeCondition",v);clearErr("tradeCondition");}} label="Fair" desc="Some visible wear or minor damage." />
                        <ChoiceCard value="poor" selected={f.tradeCondition==="poor"} onSelect={v=>{set("tradeCondition",v);clearErr("tradeCondition");}} label="Poor" desc="Significant wear or mechanical issues." />
                      </div>
                    </FG>
                    <FG label="Any accident or damage history? *" error={errors.tradeAccident}>
                      <Segment options={[{value:"yes",label:"Yes"},{value:"no",label:"No"}]} value={f.tradeAccident} onChange={v=>{set("tradeAccident",v);clearErr("tradeAccident");}} />
                    </FG>
                    {f.tradeAccident === "yes" && (
                      <FG label="Brief description">
                        <textarea className="field-textarea" style={{minHeight:60}} value={f.tradeAccidentDesc} onChange={e=>set("tradeAccidentDesc",e.target.value)} placeholder="e.g. Minor rear-end collision in 2022. Repaired through insurance." />
                      </FG>
                    )}
                    <FG label="Outstanding loan on this vehicle? *" error={errors.tradeLoan}>
                      <Segment options={[{value:"yes",label:"Yes"},{value:"no",label:"No"}]} value={f.tradeLoan} onChange={v=>{set("tradeLoan",v);clearErr("tradeLoan");}} />
                    </FG>
                    {f.tradeLoan === "yes" && (
                      <div className="field-row">
                        <FG label="Approx. Payoff ($)"><input className="field-input" type="number" value={f.tradeLoanPayoff} onChange={e=>set("tradeLoanPayoff",e.target.value)} placeholder="18500" /></FG>
                        <FG label="Lender"><input className="field-input" value={f.tradeLoanLender} onChange={e=>set("tradeLoanLender",e.target.value)} placeholder="Chase Auto" /></FG>
                      </div>
                    )}
                    <FG label="Have you received any offers on this vehicle? *" error={errors.tradeExistingOffer}>
                      <Segment options={[{value:"yes",label:"Yes"},{value:"no",label:"No"}]} value={f.tradeExistingOffer} onChange={v=>{set("tradeExistingOffer",v);clearErr("tradeExistingOffer");}} />
                    </FG>
                    {f.tradeExistingOffer === "yes" && (
                      <div className="field-row">
                        <FG label="From Where"><input className="field-input" value={f.tradeOfferSource} onChange={e=>set("tradeOfferSource",e.target.value)} placeholder="CarMax, Carvana..." /></FG>
                        <FG label="Offer Amount ($)"><input className="field-input" type="number" value={f.tradeOfferAmount} onChange={e=>set("tradeOfferAmount",e.target.value)} placeholder="24000" /></FG>
                      </div>
                    )}
                    <FG label="What do you believe this vehicle is worth?" note="Helps Even Ground understand your expectations going into the trade negotiation.">
                      <input className="field-input" type="number" value={f.tradeClientEstimate} onChange={e=>set("tradeClientEstimate",e.target.value)} placeholder="28000" style={{maxWidth:200}} />
                    </FG>
                    <FG label="Photos (optional)" note="Upload exterior, interior, or any known damage. Helpful but not required.">
                      <div className={`upload-zone ${dragging?"dragging":""}`}
                        onDragOver={e=>{e.preventDefault();setDragging(true);}}
                        onDragLeave={()=>setDragging(false)}
                        onDrop={e=>{e.preventDefault();setDragging(false);readFiles(e.dataTransfer.files);}}
                        onClick={()=>document.getElementById("trade-photo-input").click()}>
                        <div className="upload-zone-icon">📷</div>
                        <div className="upload-zone-text">{dragging?"Drop photos here":"Drag and drop or click to upload"}</div>
                        <div className="upload-zone-sub">Images accepted</div>
                        <input id="trade-photo-input" type="file" multiple accept="image/*" style={{display:"none"}} onChange={e=>readFiles(e.target.files)} />
                      </div>
                      {f.tradePhotos.length > 0 && (
                        <div className="upload-files">
                          {f.tradePhotos.map((p,i)=>(
                            <div key={i} className="upload-file-tag">
                              🖼 <span style={{maxWidth:140,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{p.name}</span>
                              <span className="upload-remove" onClick={()=>setF(prev=>({...prev,tradePhotos:prev.tradePhotos.filter((_,idx)=>idx!==i)}))}>×</span>
                            </div>
                          ))}
                        </div>
                      )}
                    </FG>
                  </div>
                )}
              </>
            )}

            {/* ── Step 5: Travel and Timeline ── */}
            {currentStep.id === "travel" && (
              <>
                <FG label="How far are you willing to travel?" error={errors.travelDistance}>
                  <div className="choice-grid two-col">
                    {["25 miles","50 miles","75 miles","100 miles","100+ miles","Nationwide"].map(d=>(
                      <ChoiceCard key={d} value={d} selected={f.travelDistance===d} onSelect={v=>{set("travelDistance",v);clearErr("travelDistance");}} label={d} />
                    ))}
                  </div>
                </FG>
                <div className="form-divider">Timeline</div>
                <FG error={errors.timeline}>
                  <div className="choice-grid">
                    <ChoiceCard value="asap" selected={f.timeline==="asap"} onSelect={v=>{set("timeline",v);clearErr("timeline");}} label="ASAP" desc="Ready to move immediately." />
                    <ChoiceCard value="two_weeks" selected={f.timeline==="two_weeks"} onSelect={v=>{set("timeline",v);clearErr("timeline");}} label="Within 2 weeks" desc="Looking to close soon." />
                    <ChoiceCard value="one_month" selected={f.timeline==="one_month"} onSelect={v=>{set("timeline",v);clearErr("timeline");}} label="Within a month" desc="Actively in the process." />
                    <ChoiceCard value="researching" selected={f.timeline==="researching"} onSelect={v=>{set("timeline",v);clearErr("timeline");}} label="Just researching" desc="Not in a rush — want to be prepared." />
                  </div>
                </FG>
              </>
            )}

            {/* ── Step 6: GAP, Warranty and Add-Ons ── */}
            {currentStep.id === "addons" && (
              <>
                <FG label="GAP Insurance" error={errors.gapInterest} note="If your vehicle is totaled or stolen, GAP covers the difference between what insurance pays and what you owe.">
                  <div className="choice-grid">
                    <ChoiceCard value="yes" selected={f.gapInterest==="yes"} onSelect={v=>{set("gapInterest",v);clearErr("gapInterest");}} label="Yes, include it" desc="I want GAP coverage built into my deal." />
                    <ChoiceCard value="discuss" selected={f.gapInterest==="discuss"} onSelect={v=>{set("gapInterest",v);clearErr("gapInterest");}} label="I'd like to discuss" desc="Even Ground will advise on whether GAP makes sense." />
                    <ChoiceCard value="no" selected={f.gapInterest==="no"} onSelect={v=>{set("gapInterest",v);clearErr("gapInterest");}} label="Not interested" />
                  </div>
                </FG>
                <div className="form-divider">Extended Warranty</div>
                <FG error={errors.warrantyInterest} note="An extended warranty or vehicle service contract covers repairs beyond the manufacturer warranty.">
                  <div className="choice-grid">
                    <ChoiceCard value="yes" selected={f.warrantyInterest==="yes"} onSelect={v=>{set("warrantyInterest",v);clearErr("warrantyInterest");}} label="Yes, include it" desc="I want an extended warranty built into my deal." />
                    <ChoiceCard value="discuss" selected={f.warrantyInterest==="discuss"} onSelect={v=>{set("warrantyInterest",v);clearErr("warrantyInterest");}} label="I'd like to discuss" desc="Even Ground will advise on whether it makes sense." />
                    <ChoiceCard value="no" selected={f.warrantyInterest==="no"} onSelect={v=>{set("warrantyInterest",v);clearErr("warrantyInterest");}} label="Not interested" />
                  </div>
                </FG>
                <div className="form-divider">Add-Ons</div>
                <FG label="Are you considering any other add-ons?" error={errors.hasAddOns}>
                  <div className="choice-grid two-col">
                    <ChoiceCard value="yes" selected={f.hasAddOns==="yes"} onSelect={v=>{set("hasAddOns",v);clearErr("hasAddOns");}} label="Yes" />
                    <ChoiceCard value="no" selected={f.hasAddOns==="no"} onSelect={v=>{set("hasAddOns",v);clearErr("hasAddOns");}} label="No" />
                  </div>
                </FG>
                {f.hasAddOns === "yes" && (
                  <FG label="What are you considering?" note="e.g. paint protection, window tint, accessories, tire and wheel protection.">
                    <textarea className="field-textarea" value={f.addOnsDescription} onChange={e=>set("addOnsDescription",e.target.value)} placeholder="Paint protection film, window tint..." />
                  </FG>
                )}
              </>
            )}

            {/* ── Step 7: Setting Expectations ── */}
            {currentStep.id === "expectations" && (
              <>
                {!isLease && !isUsed && (
                  <FG label="Maximum Budget — Out the Door ($)" note="Include taxes, fees, and all costs." error={errors.maxBudget}>
                    <input className="field-input" type="number" value={f.maxBudget} onChange={e=>{set("maxBudget",e.target.value);clearErr("maxBudget");}} placeholder="75000" style={{maxWidth:220}} />
                  </FG>
                )}
                <FG label="What would a successful outcome look like for you?" note="Price-focused, stress-free process, specific trim secured — tell us what matters most." error={errors.successOutcome}>
                  <textarea className="field-textarea" value={f.successOutcome} onChange={e=>{set("successOutcome",e.target.value);clearErr("successOutcome");}} placeholder="e.g. Getting below MSRP without the finance office pressure, and having everything agreed before I walk in." />
                </FG>
              </>
            )}

            {/* ── Step 8: Best Time for Call ── */}
            {currentStep.id === "calltime" && (
              <>
                <FG label="Best time of day *" error={errors.callBestTime}>
                  <div className="choice-grid two-col">
                    <ChoiceCard value="morning" selected={f.callBestTime==="morning"} onSelect={v=>{set("callBestTime",v);clearErr("callBestTime");}} label="Morning" desc="Before noon" />
                    <ChoiceCard value="afternoon" selected={f.callBestTime==="afternoon"} onSelect={v=>{set("callBestTime",v);clearErr("callBestTime");}} label="Afternoon" desc="Noon to 5pm" />
                    <ChoiceCard value="evening" selected={f.callBestTime==="evening"} onSelect={v=>{set("callBestTime",v);clearErr("callBestTime");}} label="Evening" desc="After 5pm" />
                    <ChoiceCard value="anytime" selected={f.callBestTime==="anytime"} onSelect={v=>{set("callBestTime",v);clearErr("callBestTime");}} label="Anytime" desc="No preference" />
                  </div>
                </FG>
                <FG label="Weekend availability">
                  <Segment
                    options={[{value:"weekdays",label:"Weekdays only"},{value:"weekends_ok",label:"Weekends ok"},{value:"no_pref",label:"No preference"}]}
                    value={f.callWeekend}
                    onChange={v=>set("callWeekend",v)}
                  />
                </FG>
              </>
            )}

            {/* ── Step 9: Contact Method ── */}
            {currentStep.id === "contact" && (
              <FG label="Preferred contact method *" error={errors.contactMethod}>
                <div className="choice-grid">
                  <ChoiceCard value="email" selected={f.contactMethod==="email"} onSelect={v=>{set("contactMethod",v);clearErr("contactMethod");}} label="Email" desc="We'll send deal updates, proposals, and questions here." />
                  <ChoiceCard value="phone" selected={f.contactMethod==="phone"} onSelect={v=>{set("contactMethod",v);clearErr("contactMethod");}} label="Phone Call" desc="We'll call to update you as the deal moves forward." />
                  <ChoiceCard value="text" selected={f.contactMethod==="text"} onSelect={v=>{set("contactMethod",v);clearErr("contactMethod");}} label="Text Message" desc="Quick updates and check-ins via text." />
                </div>
              </FG>
            )}

            {/* ── Step 10: Concerns and Questions ── */}
            {currentStep.id === "other" && (
              <FG note="Optional — share any concerns, questions, or anything else Even Ground should know before getting started.">
                <textarea className="field-textarea" style={{minHeight:130}} value={f.anythingElse}
                  onChange={e=>set("anythingElse",e.target.value)}
                  placeholder="e.g. I'm worried about being pressured at the finance office. I also have a hard deadline of the 15th." />
              </FG>
            )}

          </div>

          {submitError && (
            <div style={{margin:"0 36px 0",padding:"10px 14px",background:"#fdf0f0",border:"1px solid #f0c0c0",borderRadius:4,fontSize:12,color:"#8B2020",fontWeight:500}}>{submitError}</div>
          )}

          <div className="step-nav">
            {step > 0
              ? <button className="btn btn-back" onClick={back}>← Back</button>
              : <div />
            }
            <button className="btn btn-primary" onClick={next} disabled={submitting}>
              {step === totalSteps - 1 ? (submitting ? "Submitting..." : "Submit Intake") : "Continue →"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
